<template>
  <v-card class="grey lighten-3">
    <v-card-title class="pa-8">
      <v-row>
        <v-col>
          <span v-if="dialog.hasTitle">INFORMAÇÕES DO EVENTO</span>
        </v-col>
        <v-spacer />
        <v-btn v-if="dialog.hasCloseButton" icon elevation="0">
          <v-icon size="small" @click="close">
            mdi-close
          </v-icon>
        </v-btn>
      </v-row>
    </v-card-title>
    <v-card-text class="px-8 pt-0 event-description">
      <!-- eslint-disable-next-line vue/no-v-html -->
      <span v-html="event.sobre" />
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { DialogConfig, useDialog } from "@/stores/dialog";
import { useEventsStore } from "@/stores/events";
import Event from "@/types/Event";
import { defineComponent } from "vue";

export default defineComponent({
  computed: {
    event(): Event {
      return useEventsStore().selected!;
    },
    dialog(): DialogConfig {
      return useDialog().config;
    },
  },
  methods: {
    close() {
      this.$dialog.hide();
    },
  },
});
</script>

<style lang="scss">
.light-grey {
  background-color: #ccc !important;
}

.clickable {
  cursor: pointer;
}

.uppercase {
  text-transform: uppercase;
}

/**
Those are default formatting values for event description, to match the old styles given by the .v-application
*/
.event-description {
  font-size: 14px;
}

.event-description p {
  margin-bottom: 16px;
  font-size: 14px;
}

.event-description ul {
  padding-left: 24px;
}

.event-description a {
  color: var(--primary-color);
}

.event-description img {
  width: 100%;
}
</style>
